import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { AdditionalOrderInformationTemplate } from '../../../core/models/additional-order-information-template.model';
// eslint-disable-next-line max-len
import { AdditionalOrderInformationViewModel } from '../../../../sections/customer/edit-additional-order-information/edit-additional-order-information.view-model';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
	selector: 'cfe-additional-order-informations-preview-dialog',
	templateUrl: './additional-order-informations-preview-dialog.component.html',
	styleUrls: ['./additional-order-informations-preview-dialog.component.scss']
})
export class AdditionalOrderInformationsPreviewDialogComponent implements OnInit {
	state: AdditionalOrderInformationTemplate[];
	private cardViewModels: Map<string, AdditionalOrderInformationViewModel>;

	constructor(private formBuilder: FormBuilder, protected translate: TranslateService, protected activeModal: NgbActiveModal) {}

	ngOnInit(): void {
		this.cardViewModels = new Map<string, AdditionalOrderInformationViewModel>();

		this.state.forEach((template) => {
			const vm = new AdditionalOrderInformationViewModel(this.formBuilder, this.translate, template, true, true);
			vm.formGroup.enable();
			this.cardViewModels.set(template.uid, vm);
		});
	}

	getViewModels() {
		const array = Array.from(this.cardViewModels.values());

		array.sort((a, b) => {
			if (a.template.position > b.template.position) {
				return 1;
			} else if (a.template.position < b.template.position) {
				return -1;
			}

			return 0;
		});

		return array;
	}

	close() {
		this.activeModal.close();
	}
}
